import * as yup from 'yup';

// Lifted this from https://stackoverflow.com/questions/32044846/regex-for-iso-8601-durations

export const issueTemplateSchema = yup.array().of(yup.object().shape({
  id: yup.string().required(),
  name: yup.string().required(),
  type: yup.string().required(),
  options: yup
  .array()
  .of(
    yup.object().shape({
      value: yup.string().strict().required(),
      label: yup.string().nullable()
    })
  )
  .nullable(),
  formTypeValue: yup.string().required(),
  formLabel: yup.string().required(),
  required: yup.boolean().required(),
})).strict();